/** Label i18n + classe de cor para o estado de uma OS, na vista do cliente.
 *  Reusa as chaves `orders.status.*` existentes. */
export function estadoOSConsumer(status: string | null): { labelKey: string; classe: string } {
  switch (status) {
    case 'pendente': return { labelKey: 'orders.status.pending', classe: 'bg-yellow-100 text-yellow-800' };
    case 'aceita': return { labelKey: 'orders.status.accepted', classe: 'bg-blue-100 text-blue-800' };
    case 'em_execucao': return { labelKey: 'orders.status.inProgress', classe: 'bg-purple-100 text-purple-800' };
    case 'concluida': return { labelKey: 'orders.status.completed', classe: 'bg-green-100 text-green-800' };
    case 'cancelada': return { labelKey: 'orders.status.cancelled', classe: 'bg-muted text-muted-foreground' };
    case 'recusada': return { labelKey: 'orders.status.refused', classe: 'bg-red-100 text-red-800' };
    default: return { labelKey: 'orders.status.pending', classe: 'bg-muted text-muted-foreground' };
  }
}
